import task from '../../utils/task'

export default () => {
    task.bootstrap()
}
